export default {"src":"/_next/static/media/favicon.4f9f7ad5.svg","height":3149,"width":3149,"blurWidth":0,"blurHeight":0};